<script lang="ts">
  import CameraView from "../camera/CameraView.svelte";
  import FileInputFallback from "../camera/FileInputFallback.svelte";
  import type { CaptureSession } from "../state/captureSession";
  import { Button } from "$lib/components/ui/button";
  import * as Alert from "$lib/components/ui/alert";

  interface Props {
    session: CaptureSession;
    onClose: () => void;
  }
  const { session, onClose }: Props = $props();

  let useFallback = $state(false);
  let error = $state<string | null>(null);

  async function onCapture(blob: Blob) {
    await session.ingestPhoto(blob);
    onClose();
  }

  function onFiles(files: File[]) {
    if (files[0]) onCapture(files[0]);
  }

  function onError(msg: string) {
    error = msg;
    useFallback = true;
  }
</script>

{#if useFallback}
  <div class="scanlet-shell fixed inset-0 flex flex-col items-center justify-center gap-4 bg-background p-8">
    {#if error}
      <Alert.Root variant="destructive" class="glass-panel max-w-sm rounded-2xl border-destructive/40 bg-destructive/15">
        <Alert.Description>{error}</Alert.Description>
      </Alert.Root>
    {/if}
    <FileInputFallback label="Take photo" onSelect={onFiles} />
    <Button variant="outline" class="rounded-full border-border/70 bg-white/5 text-foreground" onclick={onClose}>Cancel</Button>
  </div>
{:else}
  <div class="fixed inset-0">
    <CameraView {onCapture} {onError} onCancel={onClose} />
  </div>
{/if}
